/* hs-eslint ignored failing-rules */
/* eslint-disable react-hooks/exhaustive-deps */

import getUsageTracker from 'pricing-pages-lib/utils/getUsageTracker';
import { useEffect } from 'react';
import { NavMarker } from 'react-rhumb';
import styled from 'styled-components';
import { SCREENS } from '../../constants/tracking/Locations';
import { useDocumentTitle } from '../../hooks/useDocumentTitle';
import { useTrackRetail } from '../../hooks/useTrackRetail';
import { hasOnlyOwnershipCheckFailedSelector, hasPricingAndPurchasingFailedSelector, hasPricingAndPurchasingSucceededSelector } from '../../selectors/LoadingStateSelectors';
import CompareStatusFooter from '../compare/CompareStatusFooter';
// import StyledBlob from '../common/StyledBlob';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { getQueryParams } from 'pricing-pages-lib/utils/queryParamUtils';
import { useHistory } from 'react-router-dom';
import { OWNERSHIP_CHECK_FAILED } from '../../constants/ErrorCauses';
import { useAddOnsPage } from '../../hooks/useAddOnPage';
import { useAppSelector } from '../../reducers';
import { productForSkuIdSelector } from '../../selectors/ProductsSelectors';
import { queryParamProductConfigurationsSelector } from '../../utils/planBuilderUtils/PlanBuilderQueryParamUtils';
import { useQueryParamTerm, useQueryParamsEffect } from '../../utils/urls/appQueryParamUtils';
import AvailableAddOnsList from '../available-add-ons-list/AvailableAddOnsList';
import { PageHeader, PageSubTitle, PageTitle } from '../common/SharedComponents';
import ErrorPage from '../error-page/ErrorPage';
import HeaderLayout from '../layout/HeaderLayout';
import FailedLoadBanner from '../common/loading/FailedLoadBanner';
import FallbackErrorBanner from '../common/loading/FallbackErrorBanner';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PageContainer = styled.main.attrs({
  role: 'main'
}).withConfig({
  displayName: "AddOnsPage__PageContainer",
  componentId: "sc-3njuab-0"
})(["width:inherit;"]);
const ContentContainer = styled.div.withConfig({
  displayName: "AddOnsPage__ContentContainer",
  componentId: "sc-3njuab-1"
})(["width:100%;max-width:684px;margin:auto;"]);
const AddOnsPage = () => {
  useTrackRetail();
  useDocumentTitle('add-ons');
  const history = useHistory();
  const queryParams = getQueryParams();
  const {
    showAddonsPage
  } = useAddOnsPage();
  const hasPricingAndPurchasingSucceeded = useAppSelector(hasPricingAndPurchasingSucceededSelector);
  const hasPricingAndPurchasingFailed = useAppSelector(hasPricingAndPurchasingFailedSelector);
  useEffect(() => {
    getUsageTracker().track('pageView', {
      screen: SCREENS.ADD_ONS
    });
  }, []);
  useEffect(() => {
    if (hasPricingAndPurchasingSucceeded && !showAddonsPage) {
      history.push('/bundle');
    }
  }, [hasPricingAndPurchasingSucceeded, showAddonsPage]);
  const hasOnlyOwnershipCheckFailed = useAppSelector(hasOnlyOwnershipCheckFailedSelector);
  const {
    queryParamTerm
  } = useQueryParamTerm();
  useQueryParamsEffect({
    term: queryParamTerm
  });
  const highlightedProduct = useAppSelector(state => {
    const queryParamProductConfigurations = hasPricingAndPurchasingSucceeded ? queryParamProductConfigurationsSelector(state, {
      queryParams
    }) : [];
    if (queryParamProductConfigurations.length === 1) {
      var _productForSkuIdSelec;
      return (_productForSkuIdSelec = productForSkuIdSelector(state, {
        skuId: queryParamProductConfigurations[0].skuId
      })) === null || _productForSkuIdSelec === void 0 ? void 0 : _productForSkuIdSelec.currentVersion;
    }
  });
  if (hasPricingAndPurchasingFailed) {
    if (hasOnlyOwnershipCheckFailed) {
      return /*#__PURE__*/_jsx(ErrorPage, {
        errorCause: OWNERSHIP_CHECK_FAILED
      });
    }
  }
  return /*#__PURE__*/_jsxs("div", {
    "data-selenium-id": "page-success",
    children: [hasPricingAndPurchasingSucceeded && /*#__PURE__*/_jsx(NavMarker, {
      name: "ADD_ONS_PAGE"
    }), /*#__PURE__*/_jsx(HeaderLayout, {
      selectedNavItem: 'add-ons',
      children: /*#__PURE__*/_jsxs(PageContainer, {
        children: [/*#__PURE__*/_jsx(FailedLoadBanner, {
          hasFailed: hasPricingAndPurchasingFailed
        }), /*#__PURE__*/_jsx(FallbackErrorBanner, {}), /*#__PURE__*/_jsxs(PageHeader, {
          children: [/*#__PURE__*/_jsx(PageTitle, {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "pricingPage.pages.addOns.title"
            })
          }), /*#__PURE__*/_jsx(PageSubTitle, {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "pricingPage.pages.addOns.subtitle"
            })
          })]
        }), /*#__PURE__*/_jsx(ContentContainer, {
          children: /*#__PURE__*/_jsx(AvailableAddOnsList, {
            screen: SCREENS.ADD_ONS,
            highlightedProduct: highlightedProduct
          })
        })]
      })
    }), /*#__PURE__*/_jsx(CompareStatusFooter, {})]
  });
};
export default AddOnsPage;